"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import type { ActivityLogParams } from "@/components/profile-activity/ProfileActivityLogs";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import type { ApiProfileRepRatesState } from "@/entities/IProfile";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { commonApiFetch } from "@/services/api/common-api";
import { RateMatter } from "@/types/enums";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "next/navigation";
import { useContext, useEffect, useState } from "react";
import UserPageIdentityHeader from "../identity/header/UserPageIdentityHeader";
import UserPageIdentityHeaderCICRate from "../identity/header/cic-rate/UserPageIdentityHeaderCICRate";
import UserPageIdentityStatements from "../identity/statements/UserPageIdentityStatements";
import UserPageRateWrapper from "../utils/rate/UserPageRateWrapper";
import UserPageCombinedActivityLog from "./UserPageCombinedActivityLog";
import UserPageRepHeader from "./header/UserPageRepHeader";
import UserPageRepMobile from "./UserPageRepMobile";
export default function UserPageRep(t0) {
  const $ = _c(49);
  const {
    profile,
    initialActivityLogParams
  } = t0;
  const {
    connectedProfile
  } = useContext(AuthContext);
  const params = useParams();
  let t1;
  if ($[0] !== params?.user) {
    t1 = (params?.user as string)?.toLowerCase();
    $[0] = params?.user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const user = t1;
  const [rater, setRater] = useState(undefined);
  let t2;
  if ($[2] !== connectedProfile?.handle) {
    t2 = () => setRater(connectedProfile?.handle?.toLowerCase());
    $[2] = connectedProfile?.handle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== connectedProfile) {
    t3 = [connectedProfile];
    $[4] = connectedProfile;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[6] !== rater || $[7] !== user) {
    t4 = [QueryKey.PROFILE_REP_RATINGS, {
      rater,
      handleOrWallet: user
    }];
    t5 = async () => await commonApiFetch({
      endpoint: `profiles/${user}/rep/ratings/received`,
      params: rater ? {
        rater
      } : {}
    });
    $[6] = rater;
    $[7] = user;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  const t6 = !!user;
  let t7;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = {
      queryKey: t4,
      queryFn: t5,
      enabled: t6
    };
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const {
    data: repRates
  } = useQuery(t7);
  const t8 = repRates ?? null;
  let t9;
  if ($[14] !== initialActivityLogParams || $[15] !== profile || $[16] !== t8) {
    t9 = <UserPageRepMobile profile={profile} repRates={t8} initialActivityLogParams={initialActivityLogParams} />;
    $[14] = initialActivityLogParams;
    $[15] = profile;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = repRates ?? null;
  let t11;
  if ($[18] !== profile || $[19] !== t10) {
    t11 = <UserPageRepHeader repRates={t10} profile={profile} />;
    $[18] = profile;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== initialActivityLogParams) {
    t12 = <div className="tw-mt-6 lg:tw-mt-8"><UserPageCombinedActivityLog initialActivityLogParams={initialActivityLogParams} /></div>;
    $[21] = initialActivityLogParams;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t11 || $[24] !== t12) {
    t13 = <div className="tw-min-w-0">{t11}{t12}</div>;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-emerald-500/[0.05] tw-via-transparent tw-to-transparent" />;
    t15 = <div className="tw-absolute tw-left-0 tw-right-0 tw-top-0 tw-h-px tw-bg-gradient-to-r tw-from-transparent tw-via-emerald-400/25 tw-to-transparent" />;
    t16 = <div className="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-h-px tw-bg-gradient-to-r tw-from-transparent tw-via-emerald-400/40 tw-to-transparent" />;
    t17 = <div className="tw-absolute tw-bottom-0 tw-left-0 tw-top-0 tw-w-px tw-bg-gradient-to-b tw-from-transparent tw-via-emerald-400/20 tw-to-transparent" />;
    t18 = <div className="tw-absolute tw-bottom-0 tw-right-0 tw-top-0 tw-w-px tw-bg-gradient-to-b tw-from-transparent tw-via-emerald-400/20 tw-to-transparent" />;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
    $[29] = t17;
    $[30] = t18;
  } else {
    t14 = $[26];
    t15 = $[27];
    t16 = $[28];
    t17 = $[29];
    t18 = $[30];
  }
  let t19;
  let t20;
  if ($[31] !== profile) {
    t19 = <UserPageIdentityHeader profile={profile} />;
    t20 = <UserPageIdentityStatements profile={profile} />;
    $[31] = profile;
    $[32] = t19;
    $[33] = t20;
  } else {
    t19 = $[32];
    t20 = $[33];
  }
  let t21;
  if ($[34] !== profile) {
    t21 = <UserPageIdentityHeaderCICRate profile={profile} isTooltip={false} />;
    $[34] = profile;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== profile || $[37] !== t21) {
    t22 = <div className="tw-px-6 tw-pb-8"><UserPageRateWrapper profile={profile} type={RateMatter.NIC} hideOwnProfileMessage={true}>{t21}</UserPageRateWrapper></div>;
    $[36] = profile;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== t19 || $[40] !== t20 || $[41] !== t22) {
    t23 = <div className="tw-min-w-0 tw-self-start"><div className="tw-relative tw-overflow-hidden tw-rounded-2xl tw-border tw-border-solid tw-border-white/[0.08] tw-bg-[#08090b]">{t14}{t15}{t16}{t17}{t18}<div className="tw-relative tw-z-10">{t19}{t20}{t22}</div></div></div>;
    $[39] = t19;
    $[40] = t20;
    $[41] = t22;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== t13 || $[44] !== t23) {
    t24 = <div className="tw-hidden lg:tw-block"><div className="tw-grid tw-grid-cols-1 tw-gap-x-8 lg:tw-grid-cols-[minmax(0,2fr)_minmax(22rem,1fr)] xl:tw-gap-x-10">{t13}{t23}</div></div>;
    $[43] = t13;
    $[44] = t23;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== t24 || $[47] !== t9) {
    t25 = <div className="tailwind-scope">{t9}{t24}</div>;
    $[46] = t24;
    $[47] = t9;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  return t25;
}